import {
	DefaultButton,
	Panel,
	PanelType,
	PrimaryButton,
	Separator,
	Stack,
} from '@fluentui/react';
import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {PeoplePicker} from 'components/hookForms/ControlledPeoplePicker';
import {User} from 'types';

export type NotificationType = {
	name: string;
	id: string;
	users: User[];
};

const AdminNotificatonEditKeywordForm = (props: {
	data: NotificationType[];
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (users: User[]) => void;
}) => {
	const {data, isOpen, onClose, onConfirm} = props;
	const {t} = useTranslation('features/adminsection', {
		keyPrefix: 'AdminNotifications',
	});

	const [currentUsers, setCurrentUsers] = useState<User[]>([]);

	useEffect(() => {
		if (isOpen && data?.[0]?.users) {
			setCurrentUsers(data[0].users);
		}
	}, [isOpen]);

	const onUserInputChange = (items: any[]) => {
		const newUsers = items.map(item => item as User);
		setCurrentUsers(newUsers);
	};

	const getForm = () => {
		if (!data || data.length === 0) {
			return <div></div>;
		}
		return (
			<div>
				<PeoplePicker
					selectedItems={currentUsers.map(u => ({...u, text: u.name}))}
					onChange={items => onUserInputChange(items ?? [])}
				/>
			</div>
		);
	};

	const onRenderFooterContent = () => (
		<>
			<Stack horizontal tokens={{childrenGap: 10}}>
				<PrimaryButton
					text={t('Confirm')}
					onClick={() => {
						onConfirm(currentUsers);
						onClose();
					}}
				/>
				<DefaultButton text={t('Cancel')} onClick={onClose} />
			</Stack>
			<Separator />
		</>
	);

	return (
		<Panel
			type={PanelType.medium}
			isOpen={isOpen}
			onDismiss={onClose}
			headerText={t('Notifications')}
			isFooterAtBottom={true}
			onRenderFooterContent={onRenderFooterContent}
		>
			<Stack>
				<div>{t('EditKeywordSubheader')}</div>
				{getForm()}
			</Stack>
		</Panel>
	);
};

export default AdminNotificatonEditKeywordForm;
